<section class="flatten-pdf">
    <h1 class="flatten-pdf__title">{{ 'flattenPdf.title' | transloco }}</h1>
    <p class="flatten-pdf__tagline">{{ 'flattenPdf.tagline' | transloco }}</p>

    <label class="flatten-pdf__upload"
           for="flatten-pdf-file"
           (drop)="onDrop($event)"
           (dragover)="onDragOver($event)"
           (dragleave)="onDragLeave($event)">
        <input id="flatten-pdf-file"
               type="file"
               accept="application/pdf"
               (change)="onFileSelected($event)"
               class="flatten-pdf__input" />
        <p class="flatten-pdf__hint" *ngIf="!selectedFile">{{ 'flattenPdf.dropHint' | transloco }}</p>
        <p class="flatten-pdf__filename" *ngIf="selectedFile">{{ selectedFile.name }}</p>
    </label>

    <div class="flatten-pdf__actions">
        <button type="button"
                class="flatten-pdf__btn flatten-pdf__btn--primary"
                [disabled]="!selectedFile || uploading"
                (click)="upload()">
            {{ uploading ? ('flattenPdf.processing' | transloco) : ('flattenPdf.flattenButton' | transloco) }}
        </button>
        <button type="button"
                class="flatten-pdf__btn flatten-pdf__btn--secondary"
                *ngIf="selectedFile && !uploading"
                (click)="clearFile()">
            {{ 'flattenPdf.clear' | transloco }}
        </button>
    </div>

    <p class="flatten-pdf__error" *ngIf="error">{{ error }}</p>
</section>
